import React, { Component } from 'react';
let i18n = require("i18next");

class ReserveSucModal extends Component {
    render() {
        return <div className="modal" id="reserveSucModal">
            <div className="reserveSuc">
                <div className="reserveSucImg">
                    <img src="/images/pos/consult/consult-reserveSuc.png"/>
                </div>

                <div className="sucWord">
                    {i18n.t("reserve.popup.sure.sucess")}<br/>
                    {i18n.t("reserve.popup.sure.sucess.inform")}
                </div>
            </div>
        </div>;
    }
}

class ReserveModal extends Component {
    render() {
        let selectDays = this.props.nextDays.map((item, index) => {
              if(item===this.props.nextDays[0]) {
                  return <span className="detailDay selectActive" data-date={item} key={index}>{i18n.t("reserve.popup.reserve.range.today")}</span>;
              } else if(item===this.props.nextDays[1]) {
                  return <span className="detailDay" data-date={item} key={index}>{i18n.t("reserve.popup.reserve.range.tomorrow")}</span>;
              } else {
                  return <span className="detailDay" data-date={item} key={index}>{item.substring(5)}</span>;
              }
        });


        return (
            <div className="modal" id="reserveModal">
                <div className="reserve modal-dialog">
                    <div style={{paddingLeft: "50px", paddingTop: "50px"}}>
                        <span style={{fontSize: 22+"px", color: '#2C2630'}} >{i18n.t("reserve.popup.title")}</span><br/>
                        <span style={{fontSize: 15+"px", color: '#2C2630', lineHeight: 40+"px"}}>{i18n.t("reserve.popup.reserve.range")}</span>
                        <br/>
                        <div className="selectDay">
                            {selectDays}
                        </div>
                        <div className="selectTime">
                            <span className="detailTime selectActive">09:30</span> <span className="detailTime">10:30</span> <span className="detailTime">11:30</span>
                            <span className="detailTime">13:30</span> <span className="detailTime">14:30</span> <span className="detailTime">15:30</span>
                        </div>
                    </div>
                    <div className="chooseInformWay" style={{position: 'relative', left: 50}}>
                        <label style={{paddingBottom: 7+"px", fontWeight: "normal"}}>{i18n.t("reserve.popup.reserve.choose.informWay")}</label>
                        <br/>
                        <label className="emailRadio"><input name="chooseInformWay" type="radio" value="email" defaultChecked/>{i18n.t("reserve.popup.reserve.informWay.email")}</label>
                        <label className="phoneRadio"><input name="chooseInformWay" type="radio" value="phone"/>{i18n.t("reserve.popup.reserve.informWay.phone")}
                            <input type="text" className="phoneInput" placeholder={i18n.t("reserve.popup.reserve.informWay.phone.input")}/></label>
                    </div>
                    <div className="noThanks">{i18n.t("reserve.popup.noThanks")}</div>
                    <div className="showReserveTime hidden"></div>
                    <div className="reserveBtn">
                        <div type="button" className="reserve"> {i18n.t("reserve.popup.sure")}</div>
                    </div>
                </div>
            </div>
        );
    }
}

export default class ConsultationModal extends Component {
    consultModal() {
        let workTime;

        if(this.props.workTime) {
            workTime = (<div type="button" className="consultBlock chartOnline">{i18n.t("consult.popup.chatOnline")}</div>);
        } else {
            workTime = (<div className="consultBlock reserveConsult">{i18n.t("consult.popup.reserveConsultTime")}</div>);
        }

        return (
            <div className="modal wide-modal" id="consultModal">
                <div className="consult modal-dialog">
                    <div style={{paddingLeft: 50, paddingTop: 50}}>
                        <span style={{fontSize: 22, color: "#2C2630"}}>{i18n.t("consult.popup.title")}</span><br/>
                        <span style={{fontSize: 15, color: "#2C2630"}}>{i18n.t("consult.popup.technical.support")}</span><br/>
                        <div style={{fontSize: 15, color: "#0493E1", paddingTop: 10}}>
                            <span>{i18n.t("consult.popup.technical.installationAndUse")}</span><br/>
                        </div>
                        <span>{i18n.t("consult.popup.technical.featuresAndBuy")}</span><br/>
                        <span>{i18n.t("consult.popup.technical.aboutSystem")}</span><br/>
                    </div>


                    <div className="pic"></div>
                    <div className="consultBlock noThanks">{i18n.t("consult.popup.noThanks")}</div>
                    <div className="consultOrReserve">
                        {workTime}
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.consultModal()}
                <ReserveModal nextDays={this.props.nextDays}/>
                <ReserveSucModal />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/react/ConsultationModal.react.js